import { Column } from 'react-table';

import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import {
  ACCOUNT_USER_DEVICE_PUSH_STATUS_TEXT,
  ACCOUNT_USER_VISITOR_DEVICE_TYPE_TEXT,
} from '../../../../../constants/service/app/accountUserConstants';
import { setColumnWidth } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import { UserDetailVisitorLogType } from './types/userDetailVisitorLog';

export type DeviceListTableColumnUtilType = {
  list: UserDetailVisitorLogType[];
  isVisitorTable: boolean;
  isVisitorLogTable: boolean;
};

type Row<T> = { value: T };
/**
 *  디바이스 리스트 컬럼
 */
export const columns = (data: DeviceListTableColumnUtilType): (Column & { fixed?: 'left' | 'right' })[] => {
  const { list, isVisitorTable = false, isVisitorLogTable = false } = data;

  return [
    {
      accessor: 'deviceType',
      Header: '기종 타입',
      fixed: 'left',
      Cell: (row: Row<UserDetailVisitorLogType['deviceType']>) =>
        ACCOUNT_USER_VISITOR_DEVICE_TYPE_TEXT[row.value] || '_',
    },
    {
      accessor: 'modelName',
      Header: '기종명',
      resizable: true,
      width: setColumnWidth(list, 'modelName'),
    },
    {
      accessor: 'uuid',
      Header: 'UUID',
      fixed: 'left',
      width: setColumnWidth(list, 'uuid'),
    },

    {
      accessor: 'os',
      Header: 'os 종류 및 버전',
    },
    {
      accessor: 'sdk',
      Header: '기기 sdk 버전',
    },
    {
      accessor: 'appVersion',
      Header: 'AMONDZ 앱 버전',
      width: 150,
    },
    {
      accessor: 'ip',
      Header: 'ip 주소',
    },
    {
      accessor: 'appPush',
      Header: '앱 푸시 동의',
      Cell: (row: Row<UserDetailVisitorLogType['appPush']>) => ACCOUNT_USER_DEVICE_PUSH_STATUS_TEXT[row.value] || '_',
    },
    {
      accessor: 'shoppingPush',
      Header: '쇼핑 푸시 동의',
      Cell: (row: Row<UserDetailVisitorLogType['shoppingPush']>) =>
        ACCOUNT_USER_DEVICE_PUSH_STATUS_TEXT[row.value] || '_',
    },
    {
      accessor: 'createDate',
      Header: '생성일',
      show: !isVisitorTable && isVisitorLogTable,
      width: 160,
      Cell: (row: Row<UserDetailVisitorLogType['createDate']>) =>
        setDateFormat(row.value, DATE_FORMAT.FULL_DASH_FORMAT),
    },
    {
      accessor: 'updateDate',
      Header: '수정일',
      show: isVisitorTable && !isVisitorLogTable,
      width: 160,
      Cell: (row: Row<UserDetailVisitorLogType['updateDate']>) =>
        setDateFormat(row.value, DATE_FORMAT.FULL_DASH_FORMAT),
    },
  ];
};
